import * as React from "react";
import { StandardProps } from "@material-ui/core";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import MuiTab, {
    TabProps as MuiTabProps,
    TabClassKey as MuiTabClassKey
} from "@material-ui/core/Tab";
import { withStyles, createStyles, Theme } from './styles';
import { StyleRulesCallback } from "@material-ui/core";


const styles = (({ palette }: Theme) => {

    return createStyles({
        root: {
            textTransform: 'initial'
        },
        selected: {},
        disabled: {},
        textColorPrimary: {
            color: palette.primary.contrastText,
            opacity: 0.7,
            '&$selected': {
                color: palette.primary.contrastText,
                opacity: 1,
            },
            '&$disabled': {
                color: palette.primary.contrastText,
                opacity: 0.4,
            },
        }
    });
}) as StyleRulesCallback;


export interface TabProps extends StandardProps<ButtonBaseProps, TabClassKey, 'onChange'> {
    disabled?: boolean;
    fullWidth?: boolean;
    icon?: string | React.ReactElement<any>;
    value?: any;
    label?: React.ReactNode;
    onChange?: (event: React.ChangeEvent<{ checked: boolean }>, value: any) => void;
    onClick?: React.EventHandler<any>;
    selected?: boolean;
    style?: React.CSSProperties;
    textColor?: string | 'secondary' | 'primary' | 'inherit';
}

export type TabClassKey = MuiTabClassKey;

class Tab extends React.PureComponent<TabProps> {



    render() {


        const { textColor, classes } = this.props;

        let tabClasses = {
            ...classes
        };

        if (textColor === 'primary') {
            tabClasses = {
                ...tabClasses,
                textColorPrimary: classes.textColorPrimary,
                selected: classes.selected,
                disabled: classes.disabled,
            }
        }

        const props: MuiTabProps = {
            ...this.props,
            classes: tabClasses
        };

        return <MuiTab {...props}>
            {this.props.children}
        </MuiTab>;
    }
}

export default withStyles(styles)(Tab);